// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Y2U-","controls":"styles_controls__XVe0v","charLimit":"styles_charLimit__1ikmn","input":"styles_input__2mMyg","send":"styles_send__3GRHm"};